import React, {
    useState,
    useCallback,
    useEffect,
    useContext,
} from 'react';
import { Transition } from 'react-transition-group';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { URLUpdater } from 'global/utils';
import { ConfigContext } from '../ConfigProvider';
import { DishDetailsContext } from './DishDeltailsContextProvider';

import { ModalSingle } from '../ModalSlider/ModalSingle';
import DishDetailsList from '../DishDetailsList';
import { DishDetailsSingle } from './DishDetailsSingle';
import { PromoCheckoutPatchedDishesContext } from '../PromoCheckoutMenuDishesAdapter';


export function DishDetailsContainer({
    dialogType = 'OLD_MODAL',
    basketDishes,
    buttonsDisabled,
}) {
    const {
        dishDetailsType,
    } = useContext(ConfigContext);

    const {
        detailsIsOpen,
        initialDishId,
        handleOpenDetails,
        handleCloseDetails,
    } = useContext(DishDetailsContext);

    const { dishesArray } = useContext(PromoCheckoutPatchedDishesContext);
    const searchParams = queryString.parse(window.location.search);

    const [isEntered, setIsEntered] = useState(false);

    const onClickOpen = useCallback((ev, toggleElement) => {
        const isUpcoming = Array.from(toggleElement?.classList)?.some((className) => className.includes('upcoming'));
        const buttonContainer = ev.target.closest('.ny__dish__add-button__container');
        const isPortionButton = buttonContainer ? !buttonContainer.classList.contains('js-open-details-button') : false;

        if (isPortionButton || isUpcoming) return;

        const el = toggleElement || ev.currentTarget;
        const dishId = el.dataset.toggleDetailsId;

        handleOpenDetails(dishId);
    }, [handleOpenDetails]);

    const listenToOpenDetailsClick = useCallback((event) => {
        const toggleElement = event.target?.closest('[data-toggle-details-id]');
        if (!toggleElement) return;

        event.preventDefault();
        onClickOpen(event, toggleElement);
    }, [onClickOpen]);

    const onClickClose = useCallback(() => {
        handleCloseDetails(700);
    }, [handleCloseDetails]);

    const showDetailsByQueryParam = useCallback(
        () => {
            const dishDetails = searchParams?.dish_details;
            if (!dishDetails) return;
            URLUpdater({ dish_details: null });
            const isDishExists = dishesArray.some(({ id }) => id === dishDetails);
            if (!isDishExists) return;
            handleOpenDetails(dishDetails);
        },
        [searchParams, dishesArray, handleOpenDetails],
    );


    useEffect(() => {
        document.body.addEventListener('click', listenToOpenDetailsClick);

        const unsubscribe = () => {
            document.body.removeEventListener('click', listenToOpenDetailsClick);
        };
        return unsubscribe;
    }, [listenToOpenDetailsClick]);

    useEffect(
        () => {
            showDetailsByQueryParam();
        },
        [showDetailsByQueryParam],
    );


    return (
        <Transition
            in={detailsIsOpen}
            onEntered={() => { setTimeout(() => { setIsEntered(true); }); }}
            onExited={() => { setTimeout(() => { setIsEntered(false); }); }}
            timeout={500}
        >
            {(transitionState) => {
                if (dishDetailsType === 'single') {
                    return (
                        <ModalSingle
                            onClickClose={onClickClose}
                            transitionState={transitionState}
                        >
                            {({ setRef }) => {
                                if (!initialDishId) return null;
                                return (
                                    <DishDetailsSingle
                                        isEntered={isEntered}
                                        initialDishId={initialDishId}
                                        basketDishes={basketDishes}
                                        buttonsDisabled={buttonsDisabled}
                                        setRef={setRef}
                                    />
                                );
                            }}
                        </ModalSingle>
                    );
                }

                return (
                    <DishDetailsList
                        dialogType={dialogType}
                        isEntered={isEntered}
                        transitionState={transitionState}
                        initialDishId={initialDishId}
                        basketDishes={basketDishes}
                        buttonsDisabled={buttonsDisabled}
                        handleCloseDetails={handleCloseDetails}
                    />
                );
            }}
        </Transition>
    );
}

DishDetailsContainer.propTypes = {
    basketDishes: PropTypes.arrayOf(
        PropTypes.shape({}),
    ).isRequired,
    buttonsDisabled: PropTypes.bool.isRequired,
    dialogType: PropTypes.string,
};
